export enum DelarPhotoType {
    DELAR_SHOP_PHOTO = 10,
    DELAR_FERTILIZER_LISCENCE_PHOTO = 20,
    DELAR_SEED_LISCENCE_PHOTO = 30,
    DELAR_PESTICIDE_LISCENCE_PHOTO = 40,
    DELAR_NEW_FERTILIZER_LISCENCE_PHOTO = 50,
    DELAR_NEW_SEED_LISCENCE_PHOTO = 60,
    DELAR_NEW_PESTICIDE_LISCENCE_PHOTO = 70,
}